module.exports = "<div class=\"ad-scrolling-bg\" style=\"background-image: url('<%=backgroundImageP%>'); background-position: 50% 0; background-repeat: <%=backgroundImagePRepeat%>\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/commercial/views/creatives/scrollbg.html
// module id = 666
// module chunks = 1